import { translateFromStorage } from '../i18n/formatTranslation';

const STORAGE_USER = 'developmentexpress_user';
const STORAGE_TOKEN = 'developmentexpress_token';
const STORAGE_REFRESH_TOKEN = 'developmentexpress_refresh_token';

const ROLE_LOGIN_MAP = {
  client: '/login/client',
  owner: '/login/owner',
  operator: '/login/operator',
  admin: '/login/admin',
};

function normalizeRole(role) {
  const normalized = String(role || '').trim().toLowerCase();
  return ROLE_LOGIN_MAP[normalized] ? normalized : null;
}

function decodeJwtRole(token) {
  if (!token) return null;
  try {
    const base64 = token.split('.')[1];
    if (!base64) return null;
    const payload = JSON.parse(atob(base64.replace(/-/g, '+').replace(/_/g, '/')));
    return normalizeRole(payload?.role);
  } catch (_e) {
    return null;
  }
}

function roleFromPathname() {
  const segment = (window.location.pathname || '').split('/').filter(Boolean)[0];
  return normalizeRole(segment);
}

export function resolveAuthRole() {
  try {
    const userData = localStorage.getItem(STORAGE_USER);
    if (userData) {
      const role = normalizeRole(JSON.parse(userData).role);
      if (role) return role;
    }
  } catch (_e) {
    // ignore parse errors
  }
  const jwtRole = decodeJwtRole(localStorage.getItem(STORAGE_TOKEN));
  if (jwtRole) return jwtRole;
  return roleFromPathname();
}

export function getRoleLoginPath(role) {
  return ROLE_LOGIN_MAP[normalizeRole(role) || resolveAuthRole()] || '/login/client';
}

export function clearLocalAuthState() {
  localStorage.removeItem(STORAGE_USER);
  localStorage.removeItem(STORAGE_TOKEN);
  localStorage.removeItem(STORAGE_REFRESH_TOKEN);
  Object.keys(localStorage)
    .filter((k) => k.startsWith('developmentexpress_avatar_'))
    .forEach((k) => localStorage.removeItem(k));
}

let sessionRedirectInProgress = false;

export function endSessionAndRedirectToLogin({ sessionRevoked = false } = {}) {
  if (sessionRedirectInProgress) return;
  sessionRedirectInProgress = true;

  const role = resolveAuthRole();
  if (sessionRevoked) {
    alert(translateFromStorage('sessionRevokedAlert'));
  }
  clearLocalAuthState();
  window.location.replace(getRoleLoginPath(role));
}

export async function logoutAndRedirect(navigate) {
  const role = resolveAuthRole();

  const refreshToken = localStorage.getItem(STORAGE_REFRESH_TOKEN);
  const token = localStorage.getItem(STORAGE_TOKEN);
  if (token && refreshToken) {
    try {
      await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/auth/logout`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ refreshToken }),
      });
    } catch (_e) {
      // silent fail — logout locally even if server call fails
    }
  }

  clearLocalAuthState();
  navigate(getRoleLoginPath(role), { replace: true });
}
